<div class="update-delivery-address">
  <app-delivery-info-form
    #deliveryFormChild
    mode="modal"
    [profileData]="profileData()"
    (formStateChange)="onFormStateChange($event)">
  </app-delivery-info-form>

  <div class="update-delivery-address__footer">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()" [disabled]="isSaving()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
      [disabled]="!formState().isAddressUpdateValid || isSaving()"
      (click)="save()">
      {{ isSaving() ? 'Saving...' : 'Save Changes' }}
    </button>
  </div>
</div>
